import stores from "cd-eft/models/Stores";
import { WaterwayDesignStore } from "cd-eft/models/Stores/WaterwayDesignStore";
import { action, observable } from "mobx";
const { waterwayDesignStore: waterwayStore } = stores.AppStore;
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';

export class WSCMiniVM {
    vegetalCoverOptions = [];
    get displayWSC() {
        return waterwayStore.showWSCMiniComp
    }

    @action.bound async getVegCover(){
      const response: any = await PRJAPI.ParameterController.getDefaultParameterByIdUsingGET(2);
      if (response.data) {
        const value = JSON.parse(response.data.json);
        this.vegetalCoverOptions = value.coverFactors.map((x) => {
          if (x.label === 'MANUAL_ENTRY') {
            return x.description
          }
          return x.description + ' (' + x.factor + ')'
        })
      }
    }

    handleCloseContainer() {
        waterwayStore.closeWscComponent();
    }

}